import { createTagFunction, parseTagFunction } from "../configuration/interface";

const getBranchTagPart = (branch: string): string => {
  const branchPart = branch ? branch.replace(/\//g, '-') : ''
  return branchPart
}

export const createEnvironmentRegExpString = (isSemverTag: boolean, isVersionedTag: boolean, environmentName: string, branch: string, namedGroups: boolean = true): string => {
  const branchPart = getBranchTagPart(branch)
  let regExpString = `^${environmentName}-`

  if (branchPart) {
    regExpString += String.raw`${branchPart}-`
  }

  if (isSemverTag) {
    regExpString += String.raw`(${namedGroups ? '?<semverVersion>' : ''}\d+\.\d+\.\d+)-`
  }

  if (isVersionedTag) {
    regExpString += String.raw`releaseNumber\.(${namedGroups ? '?<releaseNumber>' : ''}\d+)-`
  }

  // Remove trailing -
  regExpString = regExpString.slice(0, -1);
  return regExpString

}

export const createEnvironmentRegExp = (isSemverTag: boolean, isVersionedTag: boolean, environmentName: string, branch: string, namedGroups: boolean = true): RegExp => {
  const regExpString = createEnvironmentRegExpString(isSemverTag, isVersionedTag, environmentName, branch, namedGroups)
  const regExp = new RegExp(regExpString)
  return regExp
}

export const createTag: createTagFunction = (isSemverTag, isVersionedTag, releaseNumber, semverVersion, environmentName, branch) => {
  const branchPart = getBranchTagPart(branch)
  let tag = `${environmentName}-`

  if (branchPart) {
    tag += `${branchPart}-`
  }

  if (isSemverTag) {
    tag += `${semverVersion}-`
  }

  if (isVersionedTag) {
    tag += `releaseNumber.${releaseNumber}-`
  }

  // Remove trailing -
  tag = tag.slice(0, -1);
  return tag
}

export const parseTag: parseTagFunction = (isSemverTag, isVersionedTag, allTags, environmentName, branch) => {

  const environmentTagRegExp = createEnvironmentRegExp(isSemverTag, isVersionedTag, environmentName, branch)
  const parseTagVersion = (tag: string, environmentTagRegExp: RegExp): { semverVersion: string, releaseNumber: number } => {
    const { semverVersion, releaseNumber } = tag.match(environmentTagRegExp)?.groups || {}
    return { semverVersion, releaseNumber: parseInt(releaseNumber) }
  }

  const latestTag = allTags.filter(existingTag => {
    return existingTag.match(environmentTagRegExp) !== null
  }).sort((existingTagA, existingTagB) => {
    const { releaseNumber: releaseNumberA } = parseTagVersion(existingTagA, environmentTagRegExp)
    const { releaseNumber: releaseNumberB } = parseTagVersion(existingTagB, environmentTagRegExp)
    return releaseNumberA < releaseNumberB ? 1 : -1
  })[0]

  if (latestTag) {
    const { semverVersion, releaseNumber } = parseTagVersion(latestTag, environmentTagRegExp)
    return { semverVersion, releaseNumber }
  }
  return { semverVersion: isSemverTag ? '0.0.0 - not specified' : undefined, releaseNumber: isVersionedTag ? 0 : undefined }
}